import { Routes } from '@angular/router';
import { DEMOS } from './demos';
import { DemoIndexComponent } from '../demo-index/demo-index.component';
import { DemoLayoutComponent } from '../demo-layout/demo-layout.component';
import { RowLinkDetailComponent } from '../table-row-link/row-link-detail.component';

/** Роуты демо: индекс, страницы примеров (из манифеста), деталь ссылочной строки. */
export const DEMO_ROUTES: Routes = [
  { path: '', component: DemoIndexComponent },
  {
    path: 'demo',
    component: DemoLayoutComponent,
    children: DEMOS.map(d => ({ path: d.slug, component: d.component, data: { demo: d } })),
  },
  { path: 'rl-detail/:id', component: RowLinkDetailComponent },
  { path: '**', redirectTo: '' },
];
